module.exports = __webpack_public_path__ + "media/shared/assets/fonts/PlusJakartaSans/PlusJakartaSans-ExtraLight-4ecb91b6bd39779f24644ef0c7a187f0.woff2";